import React, { useEffect, useState, PureComponent } from 'react';
import { useForm } from "react-hook-form";

import { SketchPicker } from 'react-color';

import { ReactComponent as Cancel } from '../assets/cancel.svg';
import { ReactComponent as Remove } from '../assets/remove.svg';


export default function Logo ({logo, saveLogo, hideLogo}) {
    
    const imageMimeType = /image\/(png|gif|jpg|jpeg|webp|svg\+xml)/i;
    const [image, setImage] = useState(logo);
    //const [filename, setFilename] = useState();
    const [fileError, setFileError] = useState('');    
    const {
        register,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const remove = event => {
        //setFilename(false);
        setSelectedFile(false);
        saveLogo (false);        
        setImage(false)
    }
    
    const clearFile = event => {
        event.target.value = '';
    }
    
    const changeFile = event => {
        
        setFileError('');
        
        // preview image
        
        if (!event.target.files || event.target.files.length === 0) {
            setSelectedFile(false)
            return
        }
        var file = event.target.files[0];        
        //setFilename(file.name);
        setSelectedFile(file);
        
        // save
        
         if (file === 'undefined'){
            setFileError ("Not valid image");
            return;
        }           
        
        if (!imageMimeType.test(file.type)) {
            setFileError ("Image type is not valid");
            return;
        }  
        
        saveLogo (file);
    };
    
    // preview image

    const [selectedFile, setSelectedFile] = useState();
    useEffect(() => {
        if (!selectedFile) {
            //setImage(undefined)
            return
        }

        const objectUrl = URL.createObjectURL(selectedFile)
        if (objectUrl)
            setImage(objectUrl);
        
        return () => URL.revokeObjectURL(objectUrl)
    }, [selectedFile])

    
   
    
    const [message, changeMessage] = useState('');        
    const setMessage = (text) => {
        changeMessage(text)
        setTimeout(() => {
            changeMessage();
        }, 3000);
    };    
    
    
    
    return (        
        
        <div className="right right_logo "> 
                                                
            <div className="dashed-border">
            
                <div className="title"> 
                    <div>
                        <div className="name">Download logo</div>                        
                        {image ?
                            <div className="icon remove" onClick={remove}><Remove /></div>
                            :
                            null
                        }
                    </div>
                    <div>
                    
                        <div className="cancel" onClick={hideLogo}>
                            <Cancel/>
                            Close
                        </div>                                            
                    </div>
                </div>
                
                <div className="subtitle">Size 120 x 20</div>
                
                <div className="flex">
                                       

                            
                    <form>                    
                                                            
                         <input 
                            type="hidden" 
                            {...register("data[logo_last_value]", {})}
                            defaultValue={logo} 
                        />
                        <label>
                            <input 
                                type="file"
                                {...register("data[logo]", {})}
                                placeholder={"Url"}
                                onChange={changeFile}
                                onClick={clearFile}
                            />
                            <div className="button">Select File</div>
                        </label>
                        
                        {/*{filename}*/}
                        
                        <div className="error">{fileError}</div>
            
                        
                        <button type="submit" className="submit_logo_button"></button>
                        
                        
                        <div className="error">{ message }</div>
                    
                    
                    </form>
                                        
                    {image ?
                        
                        <div className="download-logo">
                            <img src={image} alt="" />
                        </div>
                        
                        :
                        
                        null                                
                    }
                
                </div>
            </div>
        </div>
        
    )

}
